// Copyright (c) 2016 Deere & Company

import actions from '../actions-list';

export const toggleAccordion = accordionId => ({
    accordionId,
    type: actions.TOGGLE_ACCORDION
});



// WEBPACK FOOTER //
// ./src/shared/components/smart-accordion/action-creators/toggle-accordion.js